"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class FlatTax {
    constructor(name, currency, value, active) {
        this.name = name;
        this.currency = currency;
        this.value = value;
        this.active = active;
        this.type = __1.eTaxType.FLAT_TAX;
    }
    static fromObj(data) {
        return new FlatTax(__1.getTaxComponentName(data), data.currency, data.value, data.active !== false);
    }
    calculate(currency, premium, fee, currencyConverter) {
        if (currency === this.currency) {
            return this.value;
        }
        return currencyConverter.convert(this.currency || currency, this.value, currency);
    }
    get description() {
        return `Flat ${this.currency} ${this.value}`;
    }
}
exports.default = FlatTax;
//# sourceMappingURL=flatTax.class.js.map